import * as React from 'react';

interface Props {
    disabled: boolean;
    date: Date;
    setDate: (date: Date) => void;
    hour?: boolean;
    day?: boolean;
}

interface State {
}

export class DatetimeForm extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        var months = [
            'Janvier',
            'Fevrier',
            'Mars',
            'Avril',
            'Mai',
            'Juin',
            'Juillet',
            'Aout',
            'Septembre',
            'Octobre',
            'Novembre',
            'Decembre',
        ];

        return (
            <div className="form-group col-6">
                <div className="form-group">
                    <div className="row">
                        {this.props.day === false ? undefined : (
                            <input
                                className="form-control-lg col-3"
                                placeholder="Jour"
                                style={{ marginRight: '5px' }}
                                type="number"
                                disabled={this.props.disabled}
                                value={this.props.date.getDate().toString()}
                                onChange={
                                    (e: React.ChangeEvent<HTMLInputElement>) => {
                                        const newDate = new Date(this.props.date);
                                        newDate.setDate(Number.parseInt(e.target.value === '' ? '1' : e.target.value));
                                        this.props.setDate(newDate);
                                    }
                                }
                            />)
                        }
                        {this.props.day === false ? undefined : (
                            <select
                                className="form-control-lg col-5"
                                style={{ marginRight: '5px' }}
                                disabled={this.props.disabled}
                                value={this.props.date.getMonth().toString()}
                                onChange={
                                    (e: React.ChangeEvent<HTMLSelectElement>) => {
                                        const newDate = new Date(this.props.date);
                                        newDate.setMonth(Number.parseInt(e.target.value));
                                        this.props.setDate(newDate);
                                    }
                                }
                            >
                                {
                                    months.map(
                                        (month: string, index: number) => {
                                            return (
                                                <option
                                                    key={index}
                                                    value={index}
                                                >
                                                    {month}
                                                </option>
                                            );
                                        }
                                    )
                                }
                            </select>)
                        }
                        {this.props.day === false ? undefined : (
                            <input
                                className="form-control-lg col-3"
                                placeholder="Année"
                                type="number"
                                disabled={this.props.disabled}
                                value={this.props.date.getFullYear().toString()}
                                onChange={
                                    (e: React.ChangeEvent<HTMLInputElement>) => {
                                        const newDate = new Date(this.props.date);
                                        newDate.setFullYear(Number.
                                        parseInt(e.target.value === '' ? '0' : e.target.value));
                                        this.props.setDate(newDate);
                                    }
                                }
                            />)
                        }
                    </div>
                    <div className="row" style={{marginTop: '5px'}}>
                        {this.props.hour === false ? undefined : (
                            <input
                                className="form-control-lg col-2"
                                placeholder="Heure"
                                style={{ marginRight: '5px' }}
                                type="number"
                                disabled={this.props.disabled}
                                value={this.props.date.getHours().toString()}
                                onChange={
                                    (e: React.ChangeEvent<HTMLInputElement>) => {
                                        const newDate = new Date(this.props.date);
                                        newDate.setHours(Number.parseInt(e.target.value === '' ? '0'
                                            : e.target.value));
                                        this.props.setDate(newDate);
                                    }
                                }
                            />
                        )}
                        {this.props.hour === false ? undefined :
                            (<p style={{ marginTop: '10px', fontSize: '20px', fontWeight: 'bolder' }}>
                                    :
                                </p>
                            )
                        }
                        {this.props.hour === false ? undefined : (
                            <input
                                className="form-control-lg col-2"
                                placeholder="Minutes"
                                type="number"
                                style={{ marginLeft: '5px' }}
                                disabled={this.props.disabled}
                                value={this.props.date.getMinutes().toString()}
                                onChange={
                                    (e: React.ChangeEvent<HTMLInputElement>) => {
                                        const newDate = new Date(this.props.date);
                                        newDate.setMinutes(Number.parseInt(e.target.value === '' ? '0' :
                                            e.target.value));
                                        this.props.setDate(newDate);
                                    }
                                }
                            />
                        )}
                    </div>

                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/Date/DatetimeForm.tsx